import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { TeleporterKey } from '../types/teleporter.type';

@Injectable({ providedIn: 'root' })
export class TeleporterService {
	private hubMap: Partial<Record<TeleporterKey, BehaviorSubject<undefined | HTMLElement>>> = {};

	public setItem(key: TeleporterKey, item: HTMLElement): void {
		this.executeIfValidKey(key, () => {
			const subject =
				this.hubMap[key] ?? new BehaviorSubject<undefined | HTMLElement>(undefined);
			this.hubMap[key] = subject;
			subject.next(item);
		});
	}

	public removeItem(key: TeleporterKey): void {
		this.executeIfValidKey(key, () => {
			const subject =
				this.hubMap[key] ?? new BehaviorSubject<undefined | HTMLElement>(undefined);
			this.hubMap[key] = subject;
			subject.next(undefined);
		});
	}

	public addHub(key: TeleporterKey): Observable<undefined | HTMLElement> | null {
		return this.executeIfValidKey(key, () => {
			const subject =
				this.hubMap[key] ?? new BehaviorSubject<undefined | HTMLElement>(undefined);
			this.hubMap[key] = subject;

			return subject.asObservable();
		});
	}

	public removeHub(key: TeleporterKey): void {
		this.executeIfValidKey(key, () => {
			const subject = this.hubMap[key];
			subject?.complete();
			// eslint-disable-next-line @typescript-eslint/no-dynamic-delete
			delete this.hubMap[key];
		});
	}

	private executeIfValidKey<T>(key: TeleporterKey, fn: () => T): T | null {
		const valid = (key as string) !== '';

		if (valid) {
			return fn();
		}

		return null;
	}
}
